import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import getVideoId from 'get-video-id';
import {BiolinkEditorService} from '../../biolink-editor.service';

export interface CrupdateWidgetDialogData {
    biolinkId: number;
    widgetId?: number;
    config?: {url?: string};
}

@Component({
    selector: 'vimeo-widget-modal',
    templateUrl: './vimeo-widget-modal.component.html',
    styleUrls: ['./vimeo-widget-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VimeoWidgetModalComponent {
    static widgetType = 'vimeoEmbed';
    errors$ = new BehaviorSubject<{url?: string}>({});
    form = new FormGroup({
        url: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<VimeoWidgetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CrupdateWidgetDialogData,
        public editor: BiolinkEditorService
    ) {
        if (data.config?.url) {
            this.form.patchValue({
                url: data.config?.url,
            });
        }
    }

    createOrUpdate() {
        const vimeoId = getVideoId(this.form.value.url).id;
        if (!vimeoId) {
            return this.errors$.next({url: 'This is not a valid vimeo url.'});
        }
        this.editor
            .crupdateWidget(
                this.data.widgetId,
                VimeoWidgetModalComponent.widgetType,
                this.form.value
            )
            .subscribe(response => {
                this.dialogRef.close(response.widget);
            });
    }

    close() {
        this.dialogRef.close();
    }
}
